import * as React from 'react';
import { HelpCircle } from 'lucide-react';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from './ui/tooltip';
import { cn } from '../lib/utils';
import { useT } from '../i18n';

// Small inline "ⓘ" help icon that reveals a plain-language explanation on
// hover / focus. Self-contained (bundles its own TooltipProvider) so it can be
// dropped next to any label without extra setup. Uses the portaled Radix
// tooltip, so it is never clipped inside scrollable modals.
export default function HelpHint({ text, className, side = 'top' }) {
  const { t } = useT();
  if (!text) return null;
  return (
    <TooltipProvider delayDuration={120}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={typeof text === 'string' ? text : t('Hint')}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
            className={cn(
              'inline-flex items-center justify-center align-middle rounded-full text-muted-foreground hover:text-foreground transition-colors cursor-help focus:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              className
            )}
          >
            <HelpCircle className="w-3.5 h-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-[300px] leading-snug">
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
